/** Decorative dotted mesh used as background texture across the landing. */
export default function DotGrid({
  color = "rgba(12,123,254,0.25)",
  size = 26,
  className = "",
  width,
  height,
}: {
  color?: string;
  size?: number;
  className?: string;
  width?: number | string;
  height?: number | string;
}) {
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 ${className}`}
      style={{
        backgroundImage: `radial-gradient(circle, ${color} 1px, transparent 1px)`,
        backgroundSize: `${size}px ${size}px`,
        ...(width !== undefined ? { width } : {}),
        ...(height !== undefined ? { height } : {}),
      }}
    />
  );
}
